module.exports = __webpack_public_path__ + "img/chinesecompany103.a2b5d219.png";